import { SelectOption } from "@/@types/SelectOption";
import { IProdutoAutorizado } from "@/interfaces/IProdutoAutorizado";
import { api } from "@/services/api";
import { produtoAutorizadoAction } from "@/store/actions/produtoAutorizado";
import { getProdutoAutorizadoSynced } from "@/store/reducers/produtoAutorizado";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export function useProdutoAutorizado() {
  const { user } = useAuth();
  const listaProdutosAutorizados = useSelector(getProdutoAutorizadoSynced);
  const appDispatch = useDispatch();
  const { sync } = produtoAutorizadoAction;
  const [produtosOptions, setProdutosOptions] = useState<SelectOption[]>([]);

  const sincronizarProdutosAutorizados = (produtos: IProdutoAutorizado[]) => {
    appDispatch(sync(produtos));
  };

  const getProdutosAutorizadosApi = async () => {
    const { data } = await api.get<IProdutoAutorizado[]>(
      `/produtos-autorizados/todos`,
      {
        headers: {
          Authorization: `Bearer ${user?.access_token}`,
        },
      }
    );
    return data;
  };

  const getProdutoAutorizadoById = (id: number) => {
    return listaProdutosAutorizados.find((produto) => produto.id === id);
  };

  const getProdutosByEstabelecimento = (estabelecimentoId: number) => {
    const produtos = listaProdutosAutorizados.filter(
      (produto) => produto.estabelecimento.id === estabelecimentoId
    );
    const options = produtos.map((produto) => ({
      label: produto.produto.nome,
      value: produto.id,
    }));

    setProdutosOptions(options);
  };

  return {
    listaProdutosAutorizados,
    sincronizarProdutosAutorizados,
    getProdutosAutorizadosApi,
    produtosOptions,
    getProdutoAutorizadoById,
    getProdutosByEstabelecimento,
  };
}
